/* USI filter bar (XCloud replacement). Drives Empire's own filter groups as pill dropdowns on desktop:
   one panel open at a time, close on outside click / Esc, active-count badges, reopen the panel after
   Empire's no-reload re-render, and "1,000+" for capped native search counts. No filtering logic here. */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 1024px)');
  var reopenLabel = null;
  function sidebar() { return document.querySelector('.productgrid--outer.layout--has-sidebar [data-productgrid-sidebar]'); }
  function label(group) { var t = group && group.querySelector('.collection-filters__filter-title'); return t ? t.textContent.trim() : ''; }
  function openLists(sb) { return Array.prototype.slice.call(sb.querySelectorAll('[data-filter-group] > [data-accordion-content].filter-group-active')); }
  function closeOthers(except) {
    var sb = sidebar(); if (!sb) return;
    openLists(sb).forEach(function (list) {
      if (list === except) return;
      var btn = list.parentElement.querySelector('[data-filter-group-trigger]');
      if (btn) btn.click();
    });
  }
  function badges() {
    var sb = sidebar(); if (!sb) return;
    Array.prototype.forEach.call(sb.querySelectorAll('[data-filter-group]'), function (g) {
      var btn = g.querySelector('[data-filter-group-trigger]'); if (!btn) return;
      var n = g.querySelectorAll('.collection-filters__filter-list-item--active').length;
      Array.prototype.forEach.call(g.querySelectorAll('.collection-filters__filter-range-input'), function (i) { if (i.value) n += 1; });
      if (n > 0) btn.setAttribute('data-usi-count', String(n)); else btn.removeAttribute('data-usi-count');
    });
  }
  function reopen() {
    if (!reopenLabel || !mq.matches) return;
    var sb = sidebar(); var want = reopenLabel; reopenLabel = null; if (!sb) return;
    Array.prototype.forEach.call(sb.querySelectorAll('[data-filter-group]'), function (g) {
      if (label(g) !== want) return;
      var list = g.querySelector('[data-accordion-content]'); var btn = g.querySelector('[data-filter-group-trigger]');
      if (btn && list && !list.classList.contains('filter-group-active')) btn.click();
    });
  }
  function searchCount() {
    if (!/\/search/.test(location.pathname)) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.tagName === 'SCRIPT') continue;
      if (/^\s*1000\s+results/i.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/1000(\s+)results/i, '1,000+$1results');
    }
  }
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var sb = sidebar(); if (!sb) return;
    var trig = e.target.closest && e.target.closest('[data-filter-group-trigger]');
    if (trig && sb.contains(trig)) {
      var list = trig.parentElement.querySelector('[data-accordion-content]');
      if (list) {
        /* keep the panel on screen: right-align it to the pill when a left-aligned panel (max 360px) would overflow */
        var r = trig.getBoundingClientRect(), vw = document.documentElement.clientWidth;
        list.classList.toggle('usi-flip', r.left + 360 > vw - 8 && r.right - 360 >= 8);
      }
      setTimeout(function () { if (list && list.classList.contains('filter-group-active')) closeOthers(list); }, 0);
      return;
    }
    var input = e.target.closest && e.target.closest('[data-filter-input]');
    if (input && sb.contains(input)) { reopenLabel = label(input.closest('[data-filter-group]')); return; }
    if (!sb.contains(e.target)) closeOthers(null);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !mq.matches) return;
    var sb = sidebar(); if (!sb) return;
    var open = openLists(sb); if (!open.length) return;
    var btn = open[0].parentElement.querySelector('[data-filter-group-trigger]');
    closeOthers(null); if (btn) btn.focus();
  });
  function init() {
    badges(); searchCount();
    var outer = document.querySelector('[data-productgrid-outer]') || document.querySelector('.productgrid--outer');
    if (outer && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { badges(); reopen(); searchCount(); }, 60); })
        .observe(outer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
